module.exports = __webpack_public_path__ + "static/media/digital-2.70144403.png";